/**
 * JavaScript Utility - json/toFormData
 * @author 서명환 <mhseo@ulalalab.com>
 */
import { isEmpty, isFileList, isJSON } from '..';

function toFormData(json = {}, parentKey, formData = new FormData()) {
  Object.entries(json).forEach(([key, value = '']) => {
    if (!isEmpty(parentKey)) {
      // key = `${parentKey}[${key}]`;
      key = parentKey;
    }

    if (isJSON(value) || isFileList(value)) {
      toFormData(value, key, formData);

      return;
    }

    // formData.set(key, value);
    formData.append(key, value);
  });

  return formData;
}

export default toFormData;
